import { render } from "./create_subject.html?vue&type=template&id=7e89fefe&external"
import script from "./create_subject.js?vue&type=script&lang=js&external"
export * from "./create_subject.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__